<template>
  <div class="filtro-content detalhes-ig">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">

        <el-switch class="switch-tipo d-inline-block"
          v-model="modelFiltros.selectedGroup"
          active-text="Cluster"
          inactive-text="Grupo">
        </el-switch>
      
       
        <el-select v-if="getWidth >= 950 && modelFiltros.selectedGroup === true" filterable clearable class="d-inline-block" size="small" v-model="modelFiltros.tipo" placeholder="Selecione o Cluster">
            <el-option
            v-for="item in optionsCluster"
            :key="item.id"
            :label="item.label"
            :value="item.id">
            </el-option>
        </el-select>

        <el-select v-if="getWidth >= 950 && modelFiltros.selectedGroup === false" filterable clearable class="d-inline-block" size="small" v-model="modelFiltros.tipo" placeholder="Selecione o Grupo">
            <el-option
            v-for="item in optionsGrupo"
            :key="item.id"
            :label="item.label"
            :value="item.id">
            </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="7" :xl="8">
        <el-button-group class="switch-top d-inline-block">
            <el-button size="small" :class="{ active: tableOptions.paginacao.pageSize === 5 }" @click="paginacaoSize(5)">Top 5</el-button>
            <el-button size="small" :class="{ active: tableOptions.paginacao.pageSize === 10 }" @click="paginacaoSize(10)">Top 10</el-button>
            <el-button size="small" :class="{ active: tableOptions.paginacao.pageSize === 20 }" @click="paginacaoSize(20)">Top 20</el-button>
            <el-button size="small" :class="{ active: tableOptions.paginacao.pageSize === 30 }" @click="paginacaoSize(30)">Top 30</el-button>
        </el-button-group>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="8">
          <el-date-picker
            class="d-inline-block"
            style="margin-right: 30px"
              width="200"
              size="small"
              ref="datepicker"
              v-model="modelFiltros.mesAno"
              type="month"
              format="MM/yyyy"
              default-value="2023-06-01">
            </el-date-picker>


            <div class="pull-right btn" @click="requestGerarRelatorio" title="Download Detalhes de IG">
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <mask id="mask0_476_2489" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="21">
                  <rect x="0.599609" y="0.5" width="20" height="20" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_476_2489)">
                  <path d="M10.5998 13.4793C10.4887 13.4793 10.3845 13.462 10.2873 13.4272C10.19 13.3925 10.0998 13.3335 10.0164 13.2502L7.01644 10.2502C6.84977 10.0835 6.76991 9.88905 6.77686 9.66683C6.7838 9.44461 6.86366 9.25016 7.01644 9.0835C7.18311 8.91683 7.38102 8.83002 7.61019 8.82308C7.83936 8.81613 8.03727 8.896 8.20394 9.06266L9.76644 10.6252V4.66683C9.76644 4.43072 9.8463 4.2328 10.006 4.07308C10.1657 3.91336 10.3637 3.8335 10.5998 3.8335C10.8359 3.8335 11.0338 3.91336 11.1935 4.07308C11.3532 4.2328 11.4331 4.43072 11.4331 4.66683V10.6252L12.9956 9.06266C13.1623 8.896 13.3602 8.81613 13.5894 8.82308C13.8185 8.83002 14.0164 8.91683 14.1831 9.0835C14.3359 9.25016 14.4157 9.44461 14.4227 9.66683C14.4296 9.88905 14.3498 10.0835 14.1831 10.2502L11.1831 13.2502C11.0998 13.3335 11.0095 13.3925 10.9123 13.4272C10.815 13.462 10.7109 13.4793 10.5998 13.4793ZM5.59977 17.1668C5.14144 17.1668 4.74908 17.0036 4.42269 16.6772C4.0963 16.3509 3.93311 15.9585 3.93311 15.5002V13.8335C3.93311 13.5974 4.01297 13.3995 4.17269 13.2397C4.33241 13.08 4.53033 13.0002 4.76644 13.0002C5.00255 13.0002 5.20047 13.08 5.36019 13.2397C5.51991 13.3995 5.59977 13.5974 5.59977 13.8335V15.5002H15.5998V13.8335C15.5998 13.5974 15.6796 13.3995 15.8394 13.2397C15.9991 13.08 16.197 13.0002 16.4331 13.0002C16.6692 13.0002 16.8671 13.08 17.0269 13.2397C17.1866 13.3995 17.2664 13.5974 17.2664 13.8335V15.5002C17.2664 15.9585 17.1032 16.3509 16.7769 16.6772C16.4505 17.0036 16.0581 17.1668 15.5998 17.1668H5.59977Z" fill="#2E2E2E"/>
                </g>
              </svg>
            </div>
            <!-- <el-button class="pull-right" size="small" type="success" icon="el-icon-download" :loading="tableOptions.load" @click="requestGerarRelatorio">Exportar</el-button>  -->
        </el-col>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div class="ig-detalhes-tbl"><!-- Indice de Gestão -->
            <el-table
                class="f360-ntable"
                v-loading="tableOptions.load"
                :data="tableOptions.data"
                :default-sort = "{ prop: 'createdAt', order: 'descending'}"
                style="width: 100%"
                stripe
                @sort-change="sortChange"
                header-cell-class-name="cell-spacing-tb"
                size="mini">

                <el-table-column
                  prop="ranking"
                  sortable
                  label="#"
                  width="60">
                </el-table-column>

                <el-table-column prop="nomeDoGrupo" label="Nome do grupo" align="left" sortable></el-table-column>
                <el-table-column prop="ig" label="IG" align="center" width="100" sortable>
                  <template slot-scope="scope" v-if="scope.row">
                    <span class="arrow-ig" :class="arrowTypeClass(scope.row.ig?.tipo)">{{ arrowType(scope.row.ig?.tipo) }}</span>
                    <span class="text-ig bold-text">{{ fixValIg(scope.row.ig?.valor) }}</span>
                  </template>
                </el-table-column>
                
                <el-table-column label="índice de Gestão" align="center"  width="300">
                  <el-table-column prop="operacional" label="Operacional" align="center" width="85" sortable>
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.operacional?.tipo)">{{ arrowType(scope.row.operacional?.tipo) }}</span>
                      <span class="text-ig bold-text">{{ fixValIg(scope.row.operacional?.valor) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="gestao" label="Gestão" align="center" width="60" sortable>
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.gestao?.tipo)">{{ arrowType(scope.row.gestao?.tipo) }}</span>
                      <span class="text-ig bold-text">{{ fixValIg(scope.row.gestao?.valor) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="login" label="Login" align="center" width="60" sortable>
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.login?.tipo)">{{ arrowType(scope.row.login?.tipo) }}</span>
                      <span class="text-ig bold-text">{{ fixValIg(scope.row.login?.valor) }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>

                <el-table-column label="Operacional" align="center" v-if="getWidth >= 1200">
                  <el-table-column prop="caixa" label="Caixa" align="right" width="100">
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.caixa?.tipo)">{{ arrowType(scope.row.caixa?.tipo) }}</span>
                      <span class="text-ig">{{ fixValIg(scope.row.caixa?.valor) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="cartao" label="Cartões" align="center" width="65">
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.cartao?.tipo)">{{ arrowType(scope.row.cartao?.tipo) }}</span>
                      <span class="text-ig">{{ fixValIg(scope.row.cartao?.valor) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="contas" label="Contas" align="center" width="60">
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.contas?.tipo)">{{ arrowType(scope.row.contas?.tipo) }}</span>
                      <span class="text-ig">{{ fixValIg(scope.row.contas?.valor) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="titulos" label="Títulos" align="center" width="60">
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.titulos?.tipo)">{{ arrowType(scope.row.titulos?.tipo) }}</span>
                      <span class="text-ig">{{ fixValIg(scope.row.titulos?.valor) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="nfe" label="NFe" align="left" width="100">
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.nfe?.tipo)">{{ arrowType(scope.row.nfe?.tipo) }}</span>
                      <span class="text-ig">{{ fixValIg(scope.row.nfe?.valor) }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>

                <el-table-column label="Gestão" align="center" v-if="getWidth >= 1000">
                  <el-table-column prop="dre" label="DRE" align="center" width="60">
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.dre?.tipo)">{{ arrowType(scope.row.dre?.tipo) }}</span>
                      <span class="text-ig">{{ fixValIg(scope.row.dre?.valor) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="dfc" label="DFC" align="center" width="60">
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.dfc?.tipo)">{{ arrowType(scope.row.dfc?.tipo) }}</span>
                      <span class="text-ig">{{ fixValIg(scope.row.dfc?.valor) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="orcamento" label="Orçamento" align="center" width="90">
                    <template slot-scope="scope" v-if="scope.row">
                      <span class="arrow-ig" :class="arrowTypeClass(scope.row.orcamento?.tipo)">{{ arrowType(scope.row.orcamento?.tipo) }}</span>
                      <span class="text-ig">{{ fixValIg(scope.row.orcamento?.valor) }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>

            </el-table><br>
            <!-- <el-pagination
              class="text-center custom-pagination"
              v-show="getWidth > 600 ? true : false"
              background
              layout="sizes, prev, jumper, next"
              @size-change="paginacaoSize"
              @current-change="paginacaoCurrent"
              :page-size="tableOptions.paginacao.pageSize"
              :current-page.sync="tableOptions.paginacao.page"
              :total="tableOptions.paginacao.total"
              :page-sizes="[5, 10, 20, 50, 75, 100]">
            </el-pagination> -->
            <f360Pagination 
              :current-page="tableOptions.paginacao.page"
              :per-page="tableOptions.paginacao.pageSize"
              :total-pages="tableOptions.paginacao.total"
              @page-change="paginacaoCurrent"/>
          </div>
        </el-col>
      </el-row>
    </div>
</template>
<script>
 import Moment from 'moment';
 import f360Pagination from '@/components/shared/f360Pagination.vue'

 const dataMock = [
    {
        "nomeDoGrupo": "CP GRUPO RDZ",
        "ig": {
            "valor": 94.26,
            "tipo": 0
        },
        "operacional": {
            "valor": 98.55,
            "tipo": 1
        },
        "gestao": {
            "valor": 76.0,
            "tipo": 0
        },
        "login": {
            "valor": 100.0,
            "tipo": 2
        },
        "caixa": {
            "valor": 98.37,
            "tipo": 0
        },
        "cartao": {
            "valor": 98.17,
            "tipo": 0
        },
        "contas": {
            "valor": 99.45,
            "tipo": 1
        },
        "titulos": {
            "valor": 99.99,
            "tipo": 1
        },
        "nfe": {
            "valor": 95.75,
            "tipo": 1
        },
        "dre": {
            "valor": 100.0,
            "tipo": 2
        },
        "dfc": {
            "valor": 65.0,
            "tipo": 0
        },
        "orcamento": {
            "valor": 0.0,
            "tipo": 2
        }
    },
    {
        "nomeDoGrupo": "GRUPO VERTICE",
        "ig": {
            "valor": 93.21,
            "tipo": 1
        },
        "operacional": {
            "valor": 94.94,
            "tipo": 1
        },
        "gestao": {
            "valor": 90.0,
            "tipo": 2
        },
        "login": {
            "valor": 90.0,
            "tipo": 2
        },
        "caixa": {
            "valor": 100.0,
            "tipo": 2
        },
        "cartao": {
            "valor": 89.69,
            "tipo": 1
        },
        "contas": {
            "valor": 92.12,
            "tipo": 0
        },
        "titulos": {
            "valor": 96.39,
            "tipo": 0
        },
        "nfe": {
            "valor": 100.0,
            "tipo": 1
        },
        "dre": {
            "valor": 100.0,
            "tipo": 2
        },
        "dfc": {
            "valor": 100.0,
            "tipo": 2
        },
        "orcamento": {
            "valor": 0.0,
            "tipo": 2
        }
    },
    {
        "nomeDoGrupo": "GRUPO PINHEIRO RJ",
        "ig": {
            "valor": 87.14,
            "tipo": 1
        },
        "operacional": {
            "valor": 88.21,
            "tipo": 1
        },
        "gestao": {
            "valor": 74.0,
            "tipo": 1
        },
        "login": {
            "valor": 100.0,
            "tipo": 2
        },
        "caixa": {
            "valor": 100.0,
            "tipo": 2
        },
        "cartao": {
            "valor": 90.43,
            "tipo": 0
        },
        "contas": {
            "valor": 96.02,
            "tipo": 1
        },
        "titulos": {
            "valor": 69.95,
            "tipo": 1
        },
        "nfe": {
            "valor": 92.76,
            "tipo": 0
        },
        "dre": {
            "valor": 100.0,
            "tipo": 1
        },
        "dfc": {
            "valor": 60.0,
            "tipo": 1
        },
        "orcamento": {
            "valor": 0.0,
            "tipo": 2
        }
    },
    {
        "nomeDoGrupo": "GRUPO RODRIGO PIAUILINO CE",
        "ig": {
            "valor": 84.09,
            "tipo": 0
        },
        "operacional": {
            "valor": 94.72,
            "tipo": 1
        },
        "gestao": {
            "valor": 52.63,
            "tipo": 0
        },
        "login": {
            "valor": 80.0,
            "tipo": 0
        },
        "caixa": {
            "valor": 100.0,
            "tipo": 2
        },
        "cartao": {
            "valor": 95.54,
            "tipo": 1
        },
        "contas": {
            "valor": 97.0,
            "tipo": 0
        },
        "titulos": {
            "valor": 100.0,
            "tipo": 1
        },
        "nfe": {
            "valor": 76.21,
            "tipo": 1
        },
        "dre": {
            "valor": 60.0,
            "tipo": 0
        },
        "dfc": {
            "valor": 56.57,
            "tipo": 2
        },
        "orcamento": {
            "valor": 0.0,
            "tipo": 2
        }
    },
    {
        "nomeDoGrupo": "GRUPO VLG",
        "ig": {
            "valor": 82.2,
            "tipo": 1
        },
        "operacional": {
            "valor": 88.01,
            "tipo": 1
        },
        "gestao": {
            "valor": 50.0,
            "tipo": 2
        },
        "login": {
            "valor": 100.0,
            "tipo": 2
        },
        "caixa": {
            "valor": 97.31,
            "tipo": 1
        },
        "cartao": {
            "valor": 77.15,
            "tipo": 0
        },
        "contas": {
            "valor": 78.16,
            "tipo": 1
        },
        "titulos": {
            "valor": 97.72,
            "tipo": 0
        },
        "nfe": {
            "valor": 93.73,
            "tipo": 1
        },
        "dre": {
            "valor": 100.0,
            "tipo": 2
        },
        "dfc": {
            "valor": 0.0,
            "tipo": 2
        },
        "orcamento": {
            "valor": 0.0,
            "tipo": 2
        }
    }
]

const filtrosModel = () => {
   return {
       selectedGroup: true,
       tipo: '',
       grupo: '',
       mesAno: Moment(new Date()).subtract(1, 'months').toDate(),
       shortcut: ''
   }
};

export default {
  name: 'DetalhesIG',
  components: {
    f360Pagination
  },
  data() {
    return {
      getWidth: window.innerWidth,
      modelFiltros: filtrosModel(),
      optionsCluster: [],
      optionsGrupo: [],
      dataMock: dataMock,
      tableOptions: {
        load: false,
        data: [],
        sort: '',
        order: '',
        paginacao: {
            page: 1,
            pageSize: 10,
            total: 10
        }
      },
      pickerOptions: {
        disabledDate(time) {
            if(!dateFromPick){
                return false
            }

            let t = Moment(new Date(dateFromPick)).subtract(3, 'M').startOf('month');
            let t2 = Moment(new Date(dateFromPick)).add(3, 'M').endOf('month');

            return !Moment(time).isBetween(t, t2);
        },
        onPick(objDates){
            if(objDates.minDate || objDates.maxDate){
                dateFromPick = objDates.minDate || objDates.maxDate
            }
        }
      },
    }
  },
  methods: {
    clickTipo(valor){
      this.modelFiltros.tipo = '';
      this.modelFiltros.selectedGroup = valor;
    },
    paginacaoCurrent(val){
      this.tableOptions.paginacao.page = val
      this.getDetalhes();
    },
    paginacaoSize(val){
      this.tableOptions.paginacao.pageSize = val
      this.tableOptions.paginacao.page = 1
      this.getDetalhes();
    },
    sortChange(val) {
      this.tableOptions.sort = val.prop
      this.tableOptions.order = val.order
      this.getDetalhes();
    },
    arrowType(tipo) {
      switch(tipo) {
        case 0: return '🠋'; break;
        case 1: return '🠉'; break;
        case 2: return '●'; break;
        default: return '●'; break;
      }
    },
    fixValIg(valor) {
      if (typeof valor === 'string' || valor instanceof String) {
        const partes = valor.split('.');
        return partes[0];
      } else if (typeof valor === 'number' && !isNaN(valor)) {
        const stringValor = valor.toString();
        const partes = stringValor.split('.');
        return partes[0];
      } else {
        return "";
      }
    },
    arrowTypeClass(tipo) {
      switch(tipo) {
        case 0: return 'arrow-ig-red'; break;
        case 1: return 'arrow-ig-green'; break;
        case 2: return 'arrow-ig-orange'; break;
        default: return 'arrow-ig-orange'; break;
      }
    },
    // requests
    async getListas(optModel, route) {
      let response = await this.axios.get(route);

      if(response.status !== 200) {
          return;
      }

      this.$data[optModel] = response.data;
    },
    async getDetalhes() {
      try {
          this.tableOptions.load = true;

          const isCluster = this.modelFiltros.selectedGroup

          const model = {
            ClusterId: isCluster ? this.modelFiltros.tipo : '',
            GrupoId: !isCluster ? this.modelFiltros.tipo : '',
            MesAno: this.modelFiltros.mesAno,
          }

          const response = await this.axios.get(this.$urls.IG_OBTER_DETALHES, {
              params: {
                ...model,
                page: this.tableOptions.paginacao.page,
                pageSize: this.tableOptions.paginacao.pageSize,
                sort: this.tableOptions.sort,
                order: this.tableOptions.order
              }
          });
          
          if(response.status !== 200){
              this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
              return;
          }

          this.tableOptions.data = response.data?.data;
          this.tableOptions.paginacao.page = response.data.page;
          this.tableOptions.paginacao.total = response.data.total;

          this.trackingF360(this, 'IG','Filtros');
      } catch(err) {

        console.error(err)
          this.$notify.error({
              title: 'Erro interno',
              message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
              position:'top-left'
          });
      }finally {
          this.tableOptions.load = false
      }
    },
    async requestGerarRelatorio(url){
      try {
          this.tableOptions.load = true;

          const isCluster = this.modelFiltros.selectedGroup

          const model = {
            ClusterId: isCluster ? this.modelFiltros.tipo : '',
            GrupoId: !isCluster ? this.modelFiltros.tipo : '',
            MesAno: this.modelFiltros.mesAno,
          }

          const response = await this.axios.get(this.$urls.IG_GERAR_RELATORIO, {
              params: {
                ...model,
                page: this.tableOptions.paginacao.page,
                pageSize: this.tableOptions.paginacao.pageSize
              }
          });

          if(response.status !== 200) {
              this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
              return;
          }

          this.$notify({
              type: "success",
              title: 'Gerando Relatório',
              dangerouslyUseHTMLString: true,
              message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
          });

          this.trackingF360(this, 'IG','Exportar');
        } catch(err) {

          console.error(err)
          
          this.$notify.error({
              title: 'Erro interno',
              message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
              position:'top-left'
          });
        }finally {
          this.tableOptions.load = false
        }
    },
  },
  watch: {
    'modelFiltros.selectedGroup'() {
      this.modelFiltros.tipo = ""
    },
    modelFiltros: {
      deep: true,
      handler(obj) {
        this.getDetalhes()
      }
    }
  },
  mounted() {
    this.getListas('optionsCluster', this.$urls.CLUSTERS);
    this.getListas('optionsGrupo', this.$urls.GRUPOS);

    this.paginacaoSize(10);

    window.addEventListener('resize', () => {
      this.getWidth = window.innerWidth;
    });
    
    /* this.$nextTick(() => {
      const htmlPagination = document.querySelectorAll('.custom-pagination .el-pagination__jump')[0].innerText
		  document.querySelectorAll('.custom-pagination .el-pagination__jump')[0].innerText = ""
		}) */

    this.trackingF360(this, 'IG','Acesso a tela');
  }
}
</script>
<style lang="scss">
.el-row {
  .el-col {
    margin-bottom: 1rem;
  }
  &:last-child {
    margin-bottom: 0;
  }
}
.detalhes-ig {
  div.switch-tipo {
    margin: 0 20px 0 0px !important;
  }
  .ig-detalhes-tbl {
    margin-top: 10px;
  }
  .ig-detalhes-tbl {
    .arrow-ig {
      // float:left;
      &.arrow-ig-green {
        color: #00CC66;
      }
      &.arrow-ig-red {
        color: #FF3033;
      }
      &.arrow-ig-orange {
        color: #FF8C00;
      }
    }
  }
  &.filtro-content .el-button.active {
    background: #f5f5f5;
    color: #626461;
  }
}
</style>